import BaseApi from '../base'

const path = '/synergy/check-in-record-detail'
class CheckInRecordDetailApi extends BaseApi {
  constructor() {
    super(path)
  }

  batchApproval = (list) => this.put(`${path}/batch-approval`, list)
}

export default new CheckInRecordDetailApi()
